import { render, staticRenderFns } from "./Name.vue?vue&type=template&id=4cf43d70&"
import script from "./Name.vue?vue&type=script&lang=js&"
export * from "./Name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports